export default "__VITE_ASSET__BLMmBtnS__"